import React, { Component } from 'react';


class Header extends Component {
  constructor() {
    super();
    this.state = {
      collapse: true,
      isScrolled: false,
    };
    this.toggleNavbarheader = this.toggleNavbarheader.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.debounceScroll);
  }

  debounceScroll(event) {
    setTimeout(() => this.handleScroll(event), 300);
  }

  handleScroll(event) {
    !this.state.collapse && this.setState({ collapse: true });
  }

  toggleNavbarheader() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }

  render() {
    const collapse = this.state.collapse ? 'collapse' : '';
    return (
      <header className="fixed-top">
        <div className="container">
          <div className="row">
            <div className="col-12 navbar-header d-lg-none">
              <a className="navbar-brand page-scroll" href="#page-top">
                <div className="align-items-center bg-base-color d-flex h-100 justify-content-center text-center">
                  <span className="font-alt2 text-large text-white">Wedding Invitation</span>
                </div>
              </a>

              <button className="navbar-toggler" type="button" onClick={this.toggleNavbarheader} aria-controls="navbar-header" aria-expanded="false" aria-label="Toggle navigation">
                <i className="fa fa-bars white" />
              </button>
            </div>

            <div className="col-lg-12 navbar-wrapper">
              <div id="navigation" className="navbar navbar-expand-lg">
                <div className={`navbar-collapse ${collapse}`} onClick={() => this.setState({ collapse: true })}>
                  <ul className="navbar-nav d-lg-flex justify-content-lg-end pr-lg-4">
                    <li className="nav-item">
                      <a className="nav-link page-scroll" href="#the-couple">The Couple</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link page-scroll" href="#wedding-event">Events</a>
                    </li>
                    {/*
                            <li className="nav-item">
                                <a className="nav-link page-scroll" href="#love-story">Love Story</a>
                            </li>
                            */}
                  </ul>

                  <ul className="navbar-nav navbar-nav-brand align-items-lg-center d-none d-lg-block">
                    <li className="nav-item align-items-center bg-base-color d-flex h-100 justify-content-center text-center w-100">
                      <span className="font-alt2 text-large text-white">Wedding Invitation</span>
                    </li>
                  </ul>

                  <ul className="navbar-nav d-lg-flex justify-content-lg-start pl-lg-4">
                    {/*
                            <li className="nav-item">
                                <a className="nav-link page-scroll" href="#photos">Photos</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link page-scroll" href="#wedding-gifts">Wedding Gifts</a>
                            </li>
                            */}
                    <li className="nav-item">
                      <a className="nav-link page-scroll" href="#rsvp">RSVP</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}
export default Header;
